import { LOGIN_SUCCESS, SET_STORE_IP_ADDRESS } from "./actionTypes";

const defaultState = {
  logindata: [],
  access_token: "",
  type: "",
  first_name: "",
  error: "",
  email: "",
  mobile: "",
  jid: "",
  jpass: "",
  ipAddress: "",
};

export const reducer = (state = defaultState, action) => {
  const { type, logindata } = action;

  switch (type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        logindata: logindata,
        access_token: logindata?.token?.access_token,
        type: logindata?.type,
        first_name: logindata?.first_name,
        email: logindata?.email,
        mobile: logindata?.mobile,
        jid: logindata?.jid,
        jpass: logindata?.jpass,
      };
    case SET_STORE_IP_ADDRESS:
      return {
        ...state,
        ip_address:action?.payload
      };
    default:
      return state;
  }
};

export default reducer;
